import axios from 'axios';
import Compressor from 'compressorjs';
import type { UploadFile } from 'antd/es/upload/interface';

export class UploadService {
  async uploadFile (files: Array<UploadFile>) {
    const data = new FormData();
    const config = {
      headers: { 'content-type': 'multipart/form-data' },
    };

    const imageMaxHeight = 1024;
    const imageMaxWidth = 1024;
    const imageConvertSize = 2000000;

    for (const file of files) {
      const compressFileObj: any = await this.compressImage(
        file.originFileObj,
        imageMaxHeight,
        imageMaxWidth,
        imageConvertSize
      );
      data.append('images[]', this.blobToFile(compressFileObj, compressFileObj.name));
    }

    return axios
      .post('/uploads/upload-image', data, config)
      .then(res => {
        if (res.status === 200) return Promise.resolve(res.data);
        throw new Error(res.data?.message);
      })
      .catch(error => {
        return Promise.reject(error);
      });
  }

  blobToFile (theBlob: any, fileName: any) {
    return new File([theBlob], fileName, {
      lastModified: new Date().getTime(),
      type: theBlob.type,
    });
  }

  compressImage (file: any, maxHeight: any, maxWidth: any, convertSize: any) {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        quality: 0.8,
        convertSize: convertSize,
        success(result: any) {
          resolve(result);
        },
        error(err: any) {
          reject(err);
        },
      });
    });
  }
}

export default new UploadService();
